import { render, staticRenderFns } from "./CommentArea.vue?vue&type=template&id=2d471407&scoped=true"
import script from "./CommentArea.vue?vue&type=script&lang=js"
export * from "./CommentArea.vue?vue&type=script&lang=js"
import style0 from "./CommentArea.vue?vue&type=style&index=0&id=2d471407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d471407",
  null
  
)

export default component.exports